(function() {
  var MAX = 5;
  var cart = {};
  var allProducts = [];
  var activeTab = 'all';
  var searchQuery = '';

  function getCategory(p) {
    var tags = Array.isArray(p.tags) ? p.tags.join(',') : (p.tags || '');
    tags = tags.toLowerCase();
    if (tags.indexOf('crypton') > -1) return 'Crypton';
    if (tags.indexOf('velvet') > -1) return 'Velvet';
    if (tags.indexOf('linen-textured-weave') > -1) return 'Linen & Textured Weave';
    if (tags.indexOf('performance') > -1) return 'Performance';
    return '';
  }

  function getCatInfo(cat) {
    var info = {
      'Performance':            { material: 'Polyester Performance Blend', pet: 'Yes', stain: 'Yes', clean: 'W' },
      'Velvet':                 { material: 'Polyester Velvet',             pet: 'No',  stain: 'No',  clean: 'S' },
      'Linen & Textured Weave': { material: 'Linen Blend',                  pet: 'No',  stain: 'No',  clean: 'S' },
      'Crypton':                { material: 'Crypton Performance Fabric',   pet: 'Yes', stain: 'Yes', clean: 'W' }
    };
    return info[cat] || { material: '—', pet: '—', stain: '—', clean: '—' };
  }

  function loadAll() {
    var p1 = fetch('/collections/fabric-swatches/products.json?limit=250&page=1').then(function(r) { return r.json(); });
    var p2 = fetch('/collections/fabric-swatches/products.json?limit=250&page=2').then(function(r) { return r.json(); });
    Promise.all([p1, p2]).then(function(results) {
      var seen = {};
      allProducts = [];
      results.forEach(function(d) {
        (d.products || []).forEach(function(p) {
          if (!seen[p.id]) { seen[p.id] = true; allProducts.push(p); }
        });
      });
      renderGrid();
    }).catch(function(e) {
      console.error('Fabric load error:', e);
      document.getElementById('csf-grid').innerHTML = '<p style="color:#999;padding:20px;">Could not load fabrics. Please refresh.</p>';
    });
  }

  function renderGrid() {
    var filtered = allProducts.filter(function(p) {
      var cat = getCategory(p);
      var matchTab = activeTab === 'all' || cat === activeTab;
      var matchSearch = !searchQuery || p.title.toLowerCase().indexOf(searchQuery) > -1;
      return matchTab && matchSearch;
    });

    document.getElementById('csf-count-label').textContent = filtered.length + ' fabric' + (filtered.length !== 1 ? 's' : '');

    if (filtered.length === 0) {
      document.getElementById('csf-grid').innerHTML = '<p style="color:#999;font-size:13px;">No fabrics found.</p>';
      return;
    }

    document.getElementById('csf-grid').innerHTML = filtered.map(function(p) {
      var varId = p.variants[0].id;
      var img   = p.images && p.images.length ? p.images[0].src : null;
      var cat   = getCategory(p);
      var inCart = !!cart[varId];
      return '<div class="csf-card' + (inCart ? ' in-cart' : '') + '" onclick="window.csfOpenPopup(' + p.id + ')">'
        + '<div class="csf-swatch">'
        + (img
            ? '<img src="' + img + '" alt="' + p.title + '" loading="lazy">'
            : '<div class="csf-swatch-placeholder"></div>')
        + '<span class="csf-added-badge">&#10003; Added</span>'
        + '</div>'
        + '<div class="csf-name">' + p.title + '</div>'
        + '<div class="csf-cat-tag">' + cat + '</div>'
        + '</div>';
    }).join('');
  }

  window.csfOpenPopup = function(productId) {
    var p = allProducts.find(function(x) { return x.id === productId; });
    if (!p) return;
    var varId = p.variants[0].id;
    var cat   = getCategory(p);
    var info  = getCatInfo(cat);
    var img   = p.images && p.images.length ? p.images[0].src : null;

    document.getElementById('csf-popup-cat').textContent        = cat;
    document.getElementById('csf-popup-title').textContent      = p.title;
    document.getElementById('csf-spec-material').textContent    = info.material;
    document.getElementById('csf-spec-pet').textContent         = info.pet;
    document.getElementById('csf-spec-stain').textContent       = info.stain;
    document.getElementById('csf-spec-clean').textContent       = info.clean;

    var imgEl = document.getElementById('csf-popup-img');
    var phEl  = document.getElementById('csf-popup-placeholder');
    if (img) {
      imgEl.src = img; imgEl.alt = p.title;
      imgEl.style.display = 'block'; phEl.style.display = 'none';
    } else {
      imgEl.style.display = 'none'; phEl.style.display = 'block';
    }

    var btn      = document.getElementById('csf-popup-add');
    var inCart   = !!cart[varId];
    var cartSize = Object.keys(cart).length;

    btn.disabled = !inCart && cartSize >= MAX;
    btn.classList.toggle('added', inCart);
    btn.textContent = inCart ? '&#10003; Added to Request'
      : (cartSize >= MAX ? 'Max 5 swatches reached' : 'Add to Sample Request');

    btn.onclick = function() {
      if (cart[varId]) { delete cart[varId]; }
      else { if (Object.keys(cart).length >= MAX) return; cart[varId] = p; }
      updateCartUI();
      renderGrid();
      window.csfOpenPopup(productId);
    };

    document.getElementById('csf-overlay').classList.add('open');
    document.body.style.overflow = 'hidden';
  };

  function updateCartUI() {
    var count = Object.keys(cart).length;
    document.getElementById('csf-count-hero').textContent = count;
    document.getElementById('csf-count-bar').textContent  = count;
    document.getElementById('csf-plural').textContent     = count === 1 ? '' : 's';
    document.getElementById('csf-cartbar').classList.toggle('visible', count > 0);
  }

  function init() {
    document.getElementById('csf-cartbar-btn').addEventListener('click', function() {
      var items = Object.keys(cart);
      if (!items.length) return;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items.map(function(id) { return { id: parseInt(id), quantity: 1 }; }) })
      }).then(function() { window.location.href = '/cart'; })
        .catch(function()  { window.location.href = '/cart'; });
    });

    document.querySelectorAll('.csf-tab').forEach(function(tab) {
      tab.addEventListener('click', function() {
        document.querySelectorAll('.csf-tab').forEach(function(t) { t.classList.remove('active'); });
        tab.classList.add('active');
        activeTab = tab.dataset.cat;
        renderGrid();
      });
    });

    document.getElementById('csf-search').addEventListener('input', function() {
      searchQuery = this.value.toLowerCase().trim();
      renderGrid();
    });

    document.getElementById('csf-popup-close').addEventListener('click', function() {
      document.getElementById('csf-overlay').classList.remove('open');
      document.body.style.overflow = '';
    });

    document.getElementById('csf-overlay').addEventListener('click', function(e) {
      if (e.target === this) { this.classList.remove('open'); document.body.style.overflow = ''; }
    });

    loadAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();